import React, { useState, useEffect } from "react";
import FontSizer from "./fontsize/FontSizer";
import axios from "axios";
// import emblem from "../assests/emblem.png";

const Header = () => {
  const [, setImage] = useState([]);

  useEffect(() => {
    const viewHeader = async () => {
      try {
        const url = `${process.env.REACT_APP_API}/viewweb/web_header`;
        const res = await axios.get(url);
        setImage(res.data.data);
      } catch (error) {
        console.log(error);
      }
    };

    viewHeader();

    return () => {
      setImage([]);
    };
  }, []);

  return (
    <>
      <FontSizer />
      <div className="bg-white px-4 py-2">
        <div className="flex justify-between">
          {/* Left: NIGST Logo */}
          <div className="w-full md:col-span-2 flex justify-center md:justify-start">
            <img
              src={require("../assests/NIGST LOGO Jan 24.png")}
              alt="NIGST Logo"
              className="w-full  h-28 object-contain"
            />
          </div>

          {/* Center: Emblem */}
          {/* <div className="w-full md:col-span-3 flex justify-center">
            <img
              src={emblem}
              alt="SOI Emblem"
              className="w-32 md:w-48 h-28 object-contain"
            />
          </div> */}

          {/* Right: DST Logo & Search Bar */}
          <div className="w-full hidden md:col-span-2 md:flex flex-col items-center justify-center space-y-2 md:mt-0">
            <img
              src={require("../assests/DST Logo.jpg")}
              alt="DST Logo"
              className="w-full  h-28 object-contain"
            />           
          </div>
        </div>
      </div>
      <div className="bg-yellow-500 h-1.5 w-full"></div>
    </>
  );
};

export default Header;
